export const SSO_PATHS = ["/login", "/logout", "/authorize"];

export const isSsoContext = (pathname = window.location.pathname) => {
  if (SSO_PATHS.some((p) => pathname.startsWith(p))) return true;
  try {
    return !localStorage.getItem("token");
  } catch (e) {
    return true;
  }
};

export const getLoaderTheme = (pathname) =>
  isSsoContext(pathname) ? "sso" : "app";
